module.exports = require("./fr-CF.d.ts");